import React, { Component } from 'react'
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Container,Box ,Link,Typography} from '@mui/material';
import Appbars from '../Appbars';
import Footer from '../Footer';

const breadcrumbs = [
    <Link underline="hover" key="1" color="inherit" href="/" sx={{fontSize:14}}>
      Home
    </Link>,
   
    <Typography key="3" color="text.primary" sx={{fontSize:14}}>
    terms-and-condition
    </Typography>,
  ];

export class Terms_and_conditon extends Component {
  render() {
    return (
      <div>  
        <Appbars/>
          <Box sx={{backgroundColor:'#f1f4f6'}}>
      <Box sx={{paddingLeft:{xs:0,sm:3},paddingRight:{xs:0,sm:3}}}>
      <Container maxWidth='xl'>
      <Box sx={{minHeight:300,mt:6}}>
<br/>
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        {breadcrumbs}
      </Breadcrumbs>
<br/>
    <Typography variant='h1' sx={{fontSize:27,fontFamily:'sans-serif',fontWeight:'800'}}>Terms and conditions</Typography> 
    <br/>
<br/>
    <Typography variant='h1' sx={{fontSize:20,fontFamily:'sans-serif',fontWeight:'600'}}>Introduction</Typography> 
    <Typography variant='body1' align='justify' sx={{fontSize:15,fontFamily:'serif',fontWeight:'500',mt:1,mb:2}}>These Terms and Conditions ("Terms") govern your access to and use of [Your Website Name] ("Website"), including any content, features, or services made available on or through the Website (collectively, the "Services"). By accessing or using the Website or Services, you agree to be bound by these Terms. If you do not agree to these Terms, you may not access or use the Website or Services.</Typography> 

    <br/>
    <Typography variant='h1' sx={{fontSize:20,fontFamily:'sans-serif',fontWeight:'600'}}> Use of the Website and Services</Typography> 
    <Typography variant='body1' align='justify' sx={{fontSize:15,fontFamily:'serif',fontWeight:'500',mt:1,mb:2}}>You may use the Website and Services only for lawful purposes and in accordance with these Terms. You agree not to:

Use the Website or Services in any way that violates any applicable federal, state, local, or international law or regulation.   
Use the Website or Services to transmit any viruses, worms, defects, Trojan horses, or other items of a destructive nature.
Use the Website or Services to harass, abuse, or impersonate any other person or entity.
Use the Website or Services to collect personal information about others without their consent.
Use the Website or Services for any commercial purpose without our prior written consent.</Typography> 


<br/>
    <Typography variant='h1' sx={{fontSize:20,fontFamily:'sans-serif',fontWeight:'600'}}> Intellectual Property</Typography> 
    <Typography variant='body1' align='justify' sx={{fontSize:15,fontFamily:'serif',fontWeight:'500',mt:1,mb:2}}>The Website and Services, including all content, features, and functionality (such as text, graphics, logos, images, audio clips, and software) are owned by [Your Company Name] or its licensors and are protected by intellectual property laws. You may not use any of the Website's or Services' content without our prior written consent.</Typography> 


    <br/>
    <Typography variant='h1' sx={{fontSize:20,fontFamily:'sans-serif',fontWeight:'600'}}>Disclaimer of Warranties</Typography> 
    <Typography variant='body1' align='justify' sx={{fontSize:15,fontFamily:'serif',fontWeight:'500',mt:1,mb:2}}>The Website and Services are provided "as is" and "as available" without warranty of any kind, express or implied. We disclaim all warranties, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, and non-infringement.</Typography> 


    <br/>
    <Typography variant='h1' sx={{fontSize:20,fontFamily:'sans-serif',fontWeight:'600'}}> Limitation of Liability</Typography> 
    <Typography variant='body1' align='justify' sx={{fontSize:15,fontFamily:'serif',fontWeight:'500',mt:1,mb:2}}>In no event shall KALRA JEWELLERS LTD. be liable for any damages whatsoever, including, but not limited to, direct, indirect, incidental, consequential, special, exemplary, or punitive damages, arising out of or in any way connected with your use of the Website or Services.</Typography> 

    <br/>
    <Typography variant='h1' sx={{fontSize:20,fontFamily:'sans-serif',fontWeight:'600'}}> Indemnification</Typography> 
    <Typography variant='body1' align='justify' sx={{fontSize:15,fontFamily:'serif',fontWeight:'500',mt:1,mb:2}}>You agree to indemnify and hold harmless [Your Company Name] and its affiliates, officers, directors, employees, agents, licensors, and suppliers from and against any claims, losses, liabilities, expenses, or demands, including attorneys' fees, made by any third party due to or arising out of your use of the Website or Services, your violation of these Terms, or your violation of any rights of another</Typography> 

    <br/>
    <Typography variant='h1' sx={{fontSize:20,fontFamily:'sans-serif',fontWeight:'600'}}> Governing Law</Typography> 
    <Typography variant='body1' align='justify' sx={{fontSize:15,fontFamily:'serif',fontWeight:'500',mt:1,mb:2}}>These Terms shall be governed by and construed in accordance with the laws of the State of [Your State]</Typography> 

    <br/>
    <Typography variant='h1' sx={{fontSize:20,fontFamily:'sans-serif',fontWeight:'600'}}> Contact Information</Typography> 
    <Typography variant='body1' align='justify' sx={{fontSize:15,fontFamily:'serif',fontWeight:'500',mt:1,mb:2}}>If you have any questions about these Terms, please contact us at1234567@gmail.com. Please note: This is just a basic template, and you may need to modify it to fit your specific needs. It is always recommended to consult with an attorney to ensure that your terms and conditions are legally sound</Typography> 








<br/>
      </Box>
      </Container>
      </Box>
      </Box>
      <Footer/>
      </div>
    )
  }
}

export default Terms_and_conditon